import './AppButton.scss';

import Button from "react-bootstrap/Button";
import PropTypes from "prop-types";
import React from "react";
const AppButton = ({
  name,
  onClick,
  size = "md",
  fullWidth = true,
  loading = false,
  leftIcon,
  rightIcon,
  disabled,
  className,

  variant = "primary", // ✅ novo
  ...rest
}) => {
  const isDisabled = disabled || loading;

  return (
    <Button
      {...rest}
      onClick={onClick}
      disabled={isDisabled}
      className={[
        "hallapp-btn",
        `hallapp-btn--${variant}`, // ✅ novo
        `hallapp-btn--${size}`,
        fullWidth ? "hallapp-btn--block" : "",
        loading ? "is-loading" : "",
        className || "",
      ].join(" ")}
      aria-busy={loading || undefined}
      type={rest.type || "button"}
    >
      {leftIcon && <span className="hallapp-btn__icon hallapp-btn__icon--left">{leftIcon}</span>}
      <span className="hallapp-btn__label">{name?.toUpperCase()}</span>
      {rightIcon && <span className="hallapp-btn__icon hallapp-btn__icon--right">{rightIcon}</span>}
    </Button>
  );
};

AppButton.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,

  // ✅ novo
  variant: PropTypes.oneOf(["primary", "danger", "secondary", "outline"]),
};

export default AppButton;
